// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { fermentationTimepointId } from './FermentationTimepoint';
import { stainResultEnum } from './StainResultEnum';
import { z } from 'zod';
export const fermentationSampleId = (z.number());
export const fermentationSample = z.object({
    id: fermentationSampleId,
    sample_weight_g: z.string().nullable(),
    is_final: z.boolean(),
    od_600: z.string().nullable(),
    cdw: z.string().nullable(),
    ph: z.string().nullable(),
    mg2_mg_l: z.string().nullable(),
    po4_mg_l: z.string().nullable(),
    nh3_mg_l: z.string().nullable(),
    ca2_mg_l: z.string().nullable(),
    fe2_mg_l: z.string().nullable(),
    k_mg_l: z.string().nullable(),
    tsp_mg_l: z.string().nullable(),
    na_mg_l: z.string().nullable(),
    methanol_v_v_pct: z.string().nullable(),
    cells_live: z.string().nullable(),
    cells_total: z.string().nullable(),
    cells_dilution: z.number().nullable(),
    smell: z.string().nullable(),
    colour: z.string().nullable(),
    sample_dry_g: z.string().nullable(),
    pellet_dry_g: z.string().nullable(),
    pellet_total_g: z.string().nullable(),
    supernatant_dry_g: z.string().nullable(),
    supernatant_total_g: z.string().nullable(),
    supernatant_wet_g: z.string().nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    potentially_contaminated: z.boolean(),
    timepoint_id: fermentationTimepointId,
    sample_wet_g: z.string().nullable(),
    glutamate_mg_l: z.string().nullable(),
    stain_result: stainResultEnum.nullable(),
});
export const fermentationSampleInitializer = z.object({
    id: fermentationSampleId.optional(),
    sample_weight_g: z.string().optional().nullable(),
    is_final: z.boolean().optional(),
    od_600: z.string().optional().nullable(),
    cdw: z.string().optional().nullable(),
    ph: z.string().optional().nullable(),
    mg2_mg_l: z.string().optional().nullable(),
    po4_mg_l: z.string().optional().nullable(),
    nh3_mg_l: z.string().optional().nullable(),
    ca2_mg_l: z.string().optional().nullable(),
    fe2_mg_l: z.string().optional().nullable(),
    k_mg_l: z.string().optional().nullable(),
    tsp_mg_l: z.string().optional().nullable(),
    na_mg_l: z.string().optional().nullable(),
    methanol_v_v_pct: z.string().optional().nullable(),
    cells_live: z.string().optional().nullable(),
    cells_total: z.string().optional().nullable(),
    cells_dilution: z.number().optional().nullable(),
    smell: z.string().optional().nullable(),
    colour: z.string().optional().nullable(),
    sample_dry_g: z.string().optional().nullable(),
    pellet_dry_g: z.string().optional().nullable(),
    pellet_total_g: z.string().optional().nullable(),
    supernatant_dry_g: z.string().optional().nullable(),
    supernatant_total_g: z.string().optional().nullable(),
    supernatant_wet_g: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    potentially_contaminated: z.boolean().optional(),
    timepoint_id: fermentationTimepointId,
    sample_wet_g: z.string().optional().nullable(),
    glutamate_mg_l: z.string().optional().nullable(),
    stain_result: stainResultEnum.optional().nullable(),
});
export const fermentationSampleMutator = z.object({
    id: fermentationSampleId.optional(),
    sample_weight_g: z.string().optional().nullable(),
    is_final: z.boolean().optional(),
    od_600: z.string().optional().nullable(),
    cdw: z.string().optional().nullable(),
    ph: z.string().optional().nullable(),
    mg2_mg_l: z.string().optional().nullable(),
    po4_mg_l: z.string().optional().nullable(),
    nh3_mg_l: z.string().optional().nullable(),
    ca2_mg_l: z.string().optional().nullable(),
    fe2_mg_l: z.string().optional().nullable(),
    k_mg_l: z.string().optional().nullable(),
    tsp_mg_l: z.string().optional().nullable(),
    na_mg_l: z.string().optional().nullable(),
    methanol_v_v_pct: z.string().optional().nullable(),
    cells_live: z.string().optional().nullable(),
    cells_total: z.string().optional().nullable(),
    cells_dilution: z.number().optional().nullable(),
    smell: z.string().optional().nullable(),
    colour: z.string().optional().nullable(),
    sample_dry_g: z.string().optional().nullable(),
    pellet_dry_g: z.string().optional().nullable(),
    pellet_total_g: z.string().optional().nullable(),
    supernatant_dry_g: z.string().optional().nullable(),
    supernatant_total_g: z.string().optional().nullable(),
    supernatant_wet_g: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    potentially_contaminated: z.boolean().optional(),
    timepoint_id: fermentationTimepointId.optional(),
    sample_wet_g: z.string().optional().nullable(),
    glutamate_mg_l: z.string().optional().nullable(),
    stain_result: stainResultEnum.optional().nullable(),
});
//# sourceMappingURL=FermentationSample.js.map